import BoardPollPortal from './BoardPollPortal/BoardPollPortal'
import useBoardHtml from './useBoardHtml'

interface BoardHtmlProps {
  html: string
}

const BoardHtml = ({ html }: BoardHtmlProps) => {
  const { containerRef, markup, targets } = useBoardHtml(html)

  return (
    <>
      <div ref={containerRef} dangerouslySetInnerHTML={markup} />
      {targets.map(target => (
        <BoardPollPortal key={target.id} target={target} />
      ))}
    </>
  )
}

export default BoardHtml
